var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcon0(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 12.3178C0 19.0856 5.6777 25.7682 14.5345 31.4707C15.0068 31.7706 15.5933 32.078 16 32.078C16.4039 32.078 16.9932 31.7706 17.4785 31.4707C26.3223 25.7682 32 19.0856 32 12.3178C32 6.49093 27.977 2.44824 22.7963 2.44824C19.7861 2.44824 17.4244 3.83362 16 5.9207C14.6017 3.84661 12.2111 2.44824 9.20369 2.44824C4.02304 2.44824 0 6.49093 0 12.3178ZM3.18889 12.3036C3.18889 8.284 5.8307 5.58582 9.37443 5.58582C12.2355 5.58582 13.8492 7.31935 14.8431 8.83207C15.2793 9.47138 15.5827 9.67698 16 9.67698C16.4173 9.67698 16.6862 9.45553 17.1512 8.83207C18.2242 7.34248 19.7775 5.58582 22.6255 5.58582C26.1692 5.58582 28.8083 8.284 28.8083 12.3036C28.8083 17.911 22.9652 24.1032 16.3041 28.5352C16.1629 28.6347 16.0634 28.7053 16 28.7053C15.9366 28.7053 15.8371 28.6347 15.7088 28.5352C9.03197 24.1032 3.18889 17.911 3.18889 12.3036Z",
    fill: "#6CD5CC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon0);
export default __webpack_public_path__ + "static/media/icon0.cb7ceff6c79a18807ad11bc175b68d7a.svg";
export { ForwardRef as ReactComponent };